import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {MatButton, MatButtonModule} from "@angular/material/button";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {Subscription} from "rxjs";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatListItem} from "@angular/material/list";
import {LanguageService} from "../../../../shared/services/language.service";
import {TranslateModule} from "@ngx-translate/core";


@Component({
  selector: 'app-product-detail-admin',
  standalone: true,
  imports: [
    MatButton,
    MatProgressSpinner,
    CardsBasicComponent,
    RouterLink,
    RouterOutlet,
    MatButtonModule,
    MatListItem,
    RouterLinkActive,
    TranslateModule,
    LocalizeRouterPipe
  ],
  templateUrl: './product-detail-admin.component.html',
  styleUrl: './product-detail-admin.component.css'
})
export class ProductDetailAdminComponent implements OnInit, OnDestroy {
  productId!: number;
  disableButtons: boolean = false;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public _languageService: LanguageService,
    private _route: ActivatedRoute) {
  }

  ngOnInit() {
    this.getRouteParams()
  }

  getRouteParams() {
    this.subscriptions.add(
      this._route.params.subscribe(params => {
        this.productId = params['productId'];
        this.disableButtons = isNaN(Number(this.productId));
      })
    );

    if (isNaN(Number(this.productId))) {
      this.disableButtons = true;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
